import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import type { FC } from 'react';

export interface RatingProps {
  rating: number;
  reviewCount: number;
}

export const RatingWithReviewCounter: FC<RatingProps> = ({ rating, reviewCount }) => {
  return (
    <Box sx={{ display: 'flex', fontSize: '14px' }}>
      <Rating value={rating} precision={0.5} readOnly size="small" />
      <div>{reviewCount > 0 ? `${rating.toFixed(2)} (${reviewCount} reviews)` : `${rating.toFixed(2)}`}</div>
    </Box>
  );
};
